import { render, staticRenderFns } from "./RestaurantDetailsDialog.vue?vue&type=template&id=1577f5f9&scoped=true"
import script from "./RestaurantDetailsDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./RestaurantDetailsDialog.vue?vue&type=style&index=0&id=1577f5f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1577f5f9",
  null
  
)

export default component.exports